import React, { Component } from "react";


class Blog extends Component{
    render(){

        let data = [
            {
                image: "blog-big-1.jpg",
                title: 'Revolucionando la agricultura con mapeo de precisión',
                link:'blog-details',
                date:'Publicado el 15 de Julio, 2025',
                postBy:'María González',
                desc: 'Descubre cómo Mapptrix está transformando la agricultura moderna mediante tecnología de mapeo satelital y análisis de suelos para optimizar la productividad de los cultivos.'
            },
            
            {
                image: "blog-big-2.jpg",
                title: 'Gestión inteligente de cultivos con datos geoespaciales',
                link:'blog-details',
                date:'Publicado el 10 de Julio, 2025',
                postBy:'Carlos Rodríguez',
                desc: 'Conoce las últimas funcionalidades de Mapptrix que permiten a los agricultores monitorear sus campos en tiempo real y tomar decisiones basadas en datos precisos de ubicación.'
            },
            {
                image: "blog-big-3.jpg",
                title: 'El futuro de la agricultura de precisión está aquí',
                link:'blog-details',
                date:'Publicado el 5 de Julio, 2025',
                postBy:'Ana Martínez',
                desc: 'Explora cómo la integración de GPS, sensores IoT y análisis predictivo en Mapptrix está revolucionando la forma en que los productores gestionan sus tierras agrícolas.'
            },
        ];
        let DataList = data.map((val, i) => {
            return(
                <div className="col-lg-4 col-md-6 col-12" key={i}>
                    <div className="blog">
                        <div className="thumb">
                            <a href={val.link}>
                                <img className="w-100" src={require(`../assets/images/blog/${val.image}`)} alt="Blog thumb"/>
                            </a>
                        </div>
                        <div className="inner">
                            <h4 className="title"><a href={val.link}>{val.title}</a></h4>
                            {/* <ul className="meta">
                                <li>{val.date}</li>
                                <li>By <a href="/">{val.postBy}</a></li>
                            </ul> */}
                            <p className="desc mt--10 mb--30">{val.desc}</p>
                            {/* <div className="blog-btn">
                                <a className="button-link" href={val.link}>Read More</a>
                            </div> */}
                        </div>
                    </div>
                </div>
            )
        });
        return(
            <div className="blog-area pt--120 pt_md--80 pt_sm--80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title text-center mb--80">
                                <h2>Nuestro <span className="theme-color">Blog</span></h2>
                                <img className="image-1" src={require('../assets/images/app/title-icon-2.png')} alt="App Landing"/>
                                <img className="image-2" src={require('../assets/images/app/title-icon.png')} alt="App Landing"/>
                                <img className="image-3" src={require('../assets/images/app/title-icon-3.png')} alt="App Landing"/>
                                <p>Descubre las últimas noticias e innovaciones en agricultura de precisión. Conoce cómo Mapptrix está revolucionando la gestión agrícola con tecnología avanzada de mapeo y análisis de datos.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {DataList}
                    </div>
                </div>
            </div>
        )
    }
}


export default Blog;

